var _rect, _path, _path2, _circle, _circle2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRealEstate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 1,
    width: 4,
    height: 12,
    rx: 2,
    fill: "#fff",
    stroke: "#525376",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.088a2 2 0 011.305-1.875l10.5-3.89a2 2 0 011.39 0l10.5 3.89a2 2 0 011.305 1.875V32a2 2 0 01-2 2h-21a2 2 0 01-2-2V12.088z",
    fill: "#fff",
    stroke: "#525376",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#525376",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    d: "M13.5 28.939L25.439 17"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 27.5,
    r: 1.75,
    fill: "#fff",
    stroke: "#525376",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 18.5,
    r: 1.75,
    fill: "#fff",
    stroke: "#525376",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.616 13.423L16.81 3.959a4 4 0 014.396-.028L35.85 13.43a2 2 0 01.608 2.738l-.374.598a2 2 0 01-2.794.612L21.23 9.463a4 4 0 00-4.438.033l-11.574 7.84A2 2 0 012.4 16.74l-.37-.593a2 2 0 01.586-2.724z",
    fill: "#fff",
    stroke: "#525376",
    strokeWidth: 2
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAzOCAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNS41IiB5PSIxIiB3aWR0aD0iNCIgaGVpZ2h0PSIxMiIgcng9IjIiIGZpbGw9IndoaXRlIiBzdHJva2U9IiM1MjUzNzYiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNNi41IDEyLjA4OEM2LjUgMTEuMjUxNCA3LjAyMDc5IDEwLjUwMzEgNy44MDUzNyAxMC4yMTI1TDE4LjMwNTQgNi4zMjM2NUMxOC43NTM2IDYuMTU3NjUgMTkuMjQ2NCA2LjE1NzY1IDE5LjY5NDYgNi4zMjM2NUwzMC4xOTQ2IDEwLjIxMjVDMzAuOTc5MiAxMC41MDMxIDMxLjUgMTEuMjUxNCAzMS41IDEyLjA4OFYzMkMzMS41IDMzLjEwNDYgMzAuNjA0NiAzNCAyOS41IDM0SDguNUM3LjM5NTQzIDM0IDYuNSAzMy4xMDQ2IDYuNSAzMlYxMi4wODhaIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSIjNTI1Mzc2IiBzdHJva2Utd2lkdGg9IjIiLz4KPGxpbmUgeDE9IjEzLjUiIHkxPSIyOC45MzkzIiB4Mj0iMjUuNDM5MyIgeTI9IjE3IiBzdHJva2U9IiM1MjUzNzYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNy41IiByPSIxLjc1IiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSIjNTI1Mzc2IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8Y2lyY2xlIGN4PSIxNSIgY3k9IjE4LjUiIHI9IjEuNzUiIGZpbGw9IndoaXRlIiBzdHJva2U9IiM1MjUzNzYiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0yLjYxNTg4IDEzLjQyMjdMMTYuODExMyAzLjk1OTEzQzE4LjEzOTcgMy4wNzM1NCAxOS44Njc1IDMuMDYyNjggMjEuMjA2OSAzLjkzMTQ4TDM1Ljg1MDEgMTMuNDI5OEMzNi43NjU4IDE0LjAyMzcgMzcuMDM2MiAxNS4yNDIyIDM2LjQ1NzcgMTYuMTY3N0wzNi4wODM3IDE2Ljc2NkMzNS40ODkxIDE3LjcxNzQgMzQuMjI4NCAxNy45OTM2IDMzLjI5MDQgMTcuMzc4MUwyMS4yMjk5IDkuNDYzMzRDMTkuODc5NiA4LjU3NzI0IDE4LjEyODkgOC41OTAwNyAxNi43OTE4IDkuNDk1ODZMNS4yMTc5NCAxNy4zMzYyQzQuMjc5NTUgMTcuOTcxOSAzLjAwMDk2IDE3LjcwMTUgMi40MDAyNSAxNi43NDA0TDIuMDI5MjggMTYuMTQ2OEMxLjQ1NTk5IDE1LjIyOTYgMS43MTU4NyAxNC4wMjI4IDIuNjE1ODggMTMuNDIyN1oiIGZpbGw9IndoaXRlIiBzdHJva2U9IiM1MjUzNzYiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";
export { SvgRealEstate as ReactComponent };